import React, { useState } from 'react';
import './Home.css';
import Notification from './Notification';

function Contact() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="home">
      {/* Header */}
      <header className="top-header">
        <div className="header-inner">
          <div className="header-logos">
            <a href="/" aria-label="Go to home page">
              <img src="img/nrb.png" alt="Logo 1" className="header-logo-img" />
            </a>
            <a href="https://ayush.gov.in/" target="_blank" rel="noopener noreferrer" aria-label="Open Ministry of Ayush website">
              <img src="img/MOA.png" alt="Logo 2" className="header-logo-img" />
            </a>
          </div>

          <div className="topbar-marquee-group">
            <Notification />
            <Notification
              variant="danger"
              messages={[
                'State registration is mandatory as part of the NRB-HPR integrated registration process. Kindly download the HPR Certificate and I-card from HPR Portal through this link https://nhpr.abdm.gov.in/nhpr/v4/login'
              ]}
            />
          </div>
        </div>
      </header>

      {/* Navbar */}
      <nav className="navbar">
        <div className="navbar-inner">
          <button
            className="nav-toggle"
            aria-label="Toggle navigation"
            onClick={() => setMenuOpen((prev) => !prev)}
          >
            <span className="nav-toggle-bar" />
            <span className="nav-toggle-bar" />
            <span className="nav-toggle-bar" />
          </button>
          <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
            <li><a href="/">Home</a></li>
            <li className="nav-dropdown">
              <a href="#about">About</a>
              <ul className="dropdown-menu">
                <li><a href="/about-us">About NRB</a></li>
                <li><a href="https://ninpune.ayush.gov.in/#!/" target="_blank" rel="noopener noreferrer">About NIN</a></li>
              </ul>
            </li>
            <li><a href="/constitution">Constitution of NRB</a></li>
            <li className="nav-dropdown">
              <a href="#directory">NRB Directory</a>
              <ul className="dropdown-menu">
                <li><a href="/doctors-list">List of Doctors Registered</a></li>
                <li><a href="/naturopathy-centers">Naturopathy Centers in India</a></li>
              </ul>
            </li>
            <li className="nav-dropdown">
              <a href="#events">Events</a>
              <ul className="dropdown-menu">
                <li><a href="/minute-of-meeting">Minute of Meeting (MOM)</a></li>
                <li><a href="/gallery">News & Events</a></li>
              </ul>
            </li>
            <li className="nav-dropdown">
              <a href="#resources">Resources</a>
              <ul className="dropdown-menu">
                <li><a href="/state-boards">State Registration Board</a></li>
                <li><a href="/medical-colleges">State Wise Yoga & Naturopathy Medical Colleges in India, 2023</a></li>
                <li><a href="/who-naturopathic-workforce">World Health Organisation (WHO) Region wise listing of countries with Naturopathic Workforce 2023</a></li>
              </ul>
            </li>
            <li className="nav-dropdown">
              <a href="#others">Others</a>
              <ul className="dropdown-menu">
                <li><a href="/bnys-syllabus">BNYS Syllabus</a></li>
                <li><a href="https://ninpune.ayush.gov.in/#!/nisargopcharVartaArchive" target="_blank" rel="noopener noreferrer">Nisargopchar Varta</a></li>
              </ul>
            </li>
            <li><a href="/contact">Contact</a></li>
            <li className="nav-cta-mobile"><a href="https://app.nrb.net.in/#/session/signin/step1">Register</a></li>
          </ul>
          <a href="https://app.nrb.net.in/#/session/signin/step1" className="nav-cta">Click here to Register</a>
        </div>
      </nav>

      {/* Contact Content */}
      <div style={{
        minHeight: '70vh',
        padding: '60px 20px',
        background: '#ffffff'
      }}>
        <div style={{
          maxWidth: '1000px',
          margin: '0 auto'
        }}>
          <h1 style={{
            fontSize: '2.5rem',
            fontWeight: 'bold',
            textAlign: 'center',
            marginBottom: '50px',
            color: '#2c3e50'
          }}>Contact Us</h1>

          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '40px',
            marginBottom: '40px'
          }}>
            {/* Contact Information */}
            <div>
              <h2 style={{
                fontSize: '1.8rem',
                marginBottom: '30px',
                color: '#2c3e50'
              }}>Get in Touch</h2>

              <div style={{ marginBottom: '30px' }}>
                <h3 style={{
                  fontSize: '1.1rem',
                  fontWeight: 'bold',
                  marginBottom: '10px',
                  color: '#555'
                }}>📍 Address</h3>
                <p style={{
                  color: '#666',
                  lineHeight: '1.6'
                }}>
                  Naturopathy Registration Board<br />
                  Under the aegis of National Institute of Naturopathy<br />
                  Nisarggram,Opposite Vidyashilp Public School, Kondhwa (Budruk), Yewalewadi, Taluka Haveli, Pune -411048, Maharashtra<br />
                  Pune: 411001
                </p>
              </div>

              <div style={{ marginBottom: '30px' }}>
                <h3 style={{
                  fontSize: '1.1rem',
                  fontWeight: 'bold',
                  marginBottom: '10px',
                  color: '#555'
                }}>📧 Email</h3>
                <p style={{ color: '#666' }}>
                  <a href="mailto:nrb@bharatmail.co.in" style={{ color: '#3498db', textDecoration: 'none' }}>
                    nrb@bharatmail.co.in
                  </a>
                </p>
              </div>

              <div style={{ marginBottom: '30px' }}>
                <h3 style={{
                  fontSize: '1.1rem',
                  fontWeight: 'bold',
                  marginBottom: '10px',
                  color: '#555'
                }}>📞 Phone</h3>
                <p style={{ color: '#666' }}>
                  <a href="tel:+918625833306" style={{ color: '#3498db', textDecoration: 'none' }}>
                    +91-86258 33306
                  </a>
                </p>
              </div>

              <div style={{ marginBottom: '30px' }}>
                <h3 style={{
                  fontSize: '1.1rem',
                  fontWeight: 'bold',
                  marginBottom: '10px',
                  color: '#555'
                }}>🕐 Working Hours</h3>
                <p style={{ color: '#666' }}>
                  Monday - Friday: 10:00 AM - 6:00 PM<br />
                  Saturday & Sunday: Closed
                </p>
              </div>
            </div>

            {/* Map */}
            <div>
              <h2 style={{
                fontSize: '1.8rem',
                marginBottom: '30px',
                color: '#2c3e50'
              }}>Our Location</h2>
              <div style={{
                borderRadius: '8px',
                overflow: 'hidden',
                boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                height: '500px',
                width: '100%'
              }}>
                <iframe
                  title="NRB Location - Nisarg Gram"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d18004.03786251469!2d73.89607851281667!3d18.443633147054!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2eb003d3bd369%3A0x4f03dcea645d09fd!2sNisarg%20Gram!5e0!3m2!1sen!2sin!4v1771407703956!5m2!1sen!2sin"
                  width="100%"
                  height="100%"
                  style={{
                    border: 'none'
                  }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-section">
            <h3 className="footer-heading">Naturopathy Registration Board</h3>
            <p className="footer-desc">
              Regulating and promoting excellence in Naturopathy education and practice across India.
            </p>
            <div className="footer-logos">
              <img src="img/nrb.png" alt="NRB Logo" className="footer-logo" />
              <img src="img/MOA.png" alt="Ministry Logo" className="footer-logo" />
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="/">Home</a></li>
              <li><a href="/about-us">About NRB</a></li>
              <li><a href="/constitution">Constitution of NRB</a></li>
              <li><a href="/doctors-list">List of Doctors Registered</a></li>
              <li><a href="/naturopathy-centers">Naturopathy Centers in India</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Important Links</h4>
            <ul className="footer-links">
              <li><a href="/minute-of-meeting">Minute of Meeting (MOM)</a></li>
              <li><a href="/gallery">News &amp; Events</a></li>
              <li><a href="/state-boards">State Registration Board</a></li>
              <li><a href="/medical-colleges">Medical Colleges</a></li>
              <li><a href="/who-naturopathic-workforce">WHO Naturopathic Workforce</a></li>
              <li><a href="/bnys-syllabus">BNYS Syllabus</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Contact Information</h4>
            <div className="footer-contact">
              <p>Dr Kajal Gupta (Domain Expert), NRB</p>
              <p>📧 nrb@bharatmail.co.in</p>
              <p>📞 86258 33306</p>
              <p>🕐 Mon-Fri: 10:00 AM - 6:00 PM</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 Naturopathy Registration Board. All rights reserved.</p>
          <div className="footer-bottom-links">
            <a href="#privacy">Privacy Policy</a>
            <span>|</span>
            <a href="#terms">Terms & Conditions</a>
            <span>|</span>
            <a href="#sitemap">Sitemap</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Contact;

